import {useSmartCaptchaLoader} from '@yandex/smart-captcha'
import { Box } from "@material-ui/core"
import { FC, useEffect } from "react";
import { useReduxSelector } from "../../hooks";

export interface TCaptchaMethods {
    onReset: () => void
    onExecute: () => void
    onDestroy: () => void
}

interface ICaptcha {
    onSuccess: (token: string) => void
    onInit: (methods: TCaptchaMethods) => void
}

export const Captcha: FC<ICaptcha> = ({onInit, onSuccess}): JSX.Element => {
    const container = `captcha-${Math.floor(Math.random() * 1000)}`
    const smartCaptcha = useSmartCaptchaLoader()
  const { recaptchaSitekey:sitekey } = useReduxSelector((state) => state.props)
    useEffect(() => {
        if (smartCaptcha && sitekey) {
            const smartCaptchaId = smartCaptcha.render(container, {sitekey, invisible: true, hideShield: true} as any)

            const methods = {
                onReset: () => smartCaptcha.reset(smartCaptchaId),
                onDestroy: () => smartCaptcha.destroy(smartCaptchaId),
                onExecute: () => smartCaptcha.execute(smartCaptchaId),
            }

            onInit(methods)

            smartCaptcha.subscribe(smartCaptchaId, 'success', (t: unknown) => onSuccess(t as string))

            smartCaptcha.subscribe(smartCaptchaId, 'token-expired', methods.onReset)

            smartCaptcha.subscribe(smartCaptchaId, 'network-error', () => console.error('Captcha error: network-error'))

            smartCaptcha.subscribe(smartCaptchaId, 'javascript-error', (e: unknown) => console.error('Captcha error:', e))

            return methods.onDestroy
        }
    }, [smartCaptcha])

    return <>{smartCaptcha && sitekey && <Box id={container}/>}</>
}
